import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
    selector: 'edit-child-modal',
    templateUrl: './edit-child-modal.component.html',
    styleUrls: ['./edit-child-modal.component.scss']
})
export class EditChildModalComponent implements OnInit {
    msg: string;
    currentlyEditingTab: string = '';

    constructor(public dialogRef: MatDialogRef<EditChildModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit(): void {}
    openDialog(): void {}

    closeDialog(closed: boolean) {
        if (this.currentlyEditingTab) {
            Swal.fire({
                titleText: 'Unsaved changes will be lost. Continue?',
                html: '<b>You are currently editing:</b> <br /><br />' + this.currentlyEditingTab,
                showDenyButton: false,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Go Back',
                icon: 'warning',
                confirmButtonColor: '#3a6b35'
            }).then((result: any) => {
                if (result.isConfirmed) {
                    this.data = { msg: this.msg, closed: closed };
                    this.dialogRef.close(this.data);
                }
            });
        } else {
            this.data = { msg: this.msg, closed: closed };
            this.dialogRef.close(this.data);
        }
    }

    editingTab(tab: string) {
        this.currentlyEditingTab = tab;
    }
}
